/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_ImportexportInputs */

const en_cmp_row_importexport = /** @type {(inputs: Cmp_Row_ImportexportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import / export formats`)
};

const id_cmp_row_importexport = /** @type {(inputs: Cmp_Row_ImportexportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format impor / ekspor`)
};

/**
* | output |
* | --- |
* | "Import / export formats" |
*
* @param {Cmp_Row_ImportexportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_importexport = /** @type {((inputs?: Cmp_Row_ImportexportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_ImportexportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_importexport(inputs)
	return en_cmp_row_importexport(inputs)
});